import { h } from 'preact'
import { useRef } from 'preact/hooks'
import { ForwardFn, forwardRef, useImperativeHandle } from 'preact/compat'

import { ElementHeightGetter } from 'components/ui'

import classes from './index.scss'

const SAFE_AREA_DOM_ID = '_howxm-safe-area'

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {}

export type SafeAreaRefType = {
  getHeight: () => void
}

const SafeArea: ForwardFn<Props, SafeAreaRefType> = (_, ref) => {
  const safeAreaHeight = useRef<number>(0)

  useImperativeHandle(ref, () => ({
    getHeight: () => {
      return safeAreaHeight.current
    },
  }))

  return (
    <ElementHeightGetter
      onHeight={(height) => {
        if (height) {
          safeAreaHeight.current = height
        }
      }}
    >
      <div id={SAFE_AREA_DOM_ID} className={classes.safeArea} />
    </ElementHeightGetter>
  )
}

export default forwardRef(SafeArea)
